const PIXELS_IN_PLOT_SECOND = 157;

export { PIXELS_IN_PLOT_SECOND };
